import DescriptionIcon from "@mui/icons-material/Description"
import LogoutIcon from "@mui/icons-material/Logout"
import SettingsIcon from "@mui/icons-material/Settings"
import {
  AppBar,
  Avatar,
  Box,
  Button,
  Divider,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@mui/material"
import { useState } from "react"
import { Link } from "react-router-dom"
import { useAuth } from "../hooks/useAuth"
import { OrgSelector } from "./OrgSelector"

function AppBarComponent() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const { user, logout } = useAuth()

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    handleMenuClose()
    logout()
  }

  const getUserInitials = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName[0]}${user.lastName[0]}`.toUpperCase()
    }
    if (user?.email) {
      return user.email[0].toUpperCase()
    }
    return "U"
  }

  const getUserDisplayName = () => {
    if (user?.firstName && user?.lastName) {
      return `${user.firstName} ${user.lastName}`
    }
    return user?.email || "User"
  }

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar>
        <Typography
          variant="h6"
          component={Link}
          to="/"
          sx={{ flexGrow: 1, textDecoration: "none" }}
          color="inherit"
        >
          MobileMind Data Portal
        </Typography>

        <Box>
          <OrgSelector />
        </Box>

        <Button
          color="inherit"
          startIcon={<DescriptionIcon />}
          component={Link}
          to="/api-docs"
          sx={{ ml: 2 }}
        >
          API Docs
        </Button>

        <IconButton
          onClick={handleMenuOpen}
          sx={{ ml: 2 }}
          aria-controls="user-menu"
          aria-haspopup="true"
        >
          <Avatar
            sx={{
              bgcolor: "secondary.main",
              width: 36,
              height: 36,
              fontSize: "0.875rem",
            }}
          >
            {getUserInitials()}
          </Avatar>
        </IconButton>

        <Menu
          id="user-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <MenuItem disabled>
            <Box>
              <Typography variant="subtitle2">
                {getUserDisplayName()}
              </Typography>
              {user?.email && (
                <Typography variant="caption" color="textSecondary">
                  {user.email}
                </Typography>
              )}
            </Box>
          </MenuItem>
          <Divider />
          <MenuItem component={Link} to="/settings" onClick={handleMenuClose}>
            <ListItemIcon>
              <SettingsIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Organization Settings</ListItemText>
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  )
}

export default AppBarComponent
